import { render } from "./selectHuati.vue?vue&type=template&id=497af2d4&scoped=true"
import script from "./selectHuati.vue?vue&type=script&lang=js"
export * from "./selectHuati.vue?vue&type=script&lang=js"

import "./selectHuati.vue?vue&type=style&index=0&id=497af2d4&lang=less&scoped=scoped"
import "./selectHuati.vue?vue&type=style&index=1&id=497af2d4&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497af2d4"]])

export default __exports__